
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { StrategyProviderUser } from "./types";

// Fetch strategy provider users
export const useUsersQuery = () => {
  return useQuery({
    queryKey: ['strategyProviderUsers'],
    queryFn: fetchStrategyProviderUsers,
    retry: 1,  // Only retry once on failure
    refetchOnWindowFocus: false,  // Don't refetch when window regains focus
    staleTime: 5 * 60 * 1000,  // Consider data fresh for 5 minutes
  });
};

const fetchStrategyProviderUsers = async (): Promise<StrategyProviderUser[]> => {
  try {
    const { data: roleData, error } = await supabase
      .from('user_roles')
      .select('user_id, first_name, last_name')
      .eq('role', 'strategy_provider');
    
    if (error) throw error;
    
    // Get email addresses from auth.users
    const users: StrategyProviderUser[] = [];
    
    for (const role of roleData) {
      try {
        // Get email from auth.users
        const { data: userData, error: userError } = await supabase.auth.admin.getUserById(role.user_id);
        
        if (!userError && userData?.user) {
          users.push({
            id: role.user_id,
            email: userData.user.email || 'Unknown email',
            firstName: role.first_name || '',
            lastName: role.last_name || ''
          });
        }
      } catch (err) {
        console.error("Error fetching user data:", err);
      }
    }
    
    return users;
  } catch (err) {
    console.error("Error fetching strategy provider users:", err);
    return [];  // Return empty array on error to avoid crashing
  }
};
